import React from "react";
import "./Nosotros.css";
import TargetIcon from "@mui/icons-material/Adjust"; // Para Misión
import VisionIcon from "@mui/icons-material/Visibility"; // Para Visión
import QualityIcon from "@mui/icons-material/WorkspacePremium"; // Para Calidad
import useInView from "../../hooks/useInView";

const Nosotros = () => {
  // Usamos el hook useInView para detectar cuando las cards están a la vista
  const [isInView, cardsRef] = useInView(0.1); // 0.1 es el umbral (10% visible)

  return (
    <div className="nosotros-container" id="empresa">
      {/* Encabezado */}
      <section className="nosotros-header">
        <h1>AUTOELEVADORES ECHARRI</h1>
        <p className="subheading">
          Líderes en soluciones de alquiler, venta y mantenimiento de equipos
          industriales.
        </p>
      </section>

      {/* Contenido */}
      <section className="nosotros-content">
        {/* Cards de Misión, Visión y Valores */}
        <div
          className={`cards-section ${isInView ? "visible" : ""}`}
          ref={cardsRef}
        >
          <div className="card">
            <div className="icon">
              <TargetIcon className="icon" />
            </div>
            <h3>MISIÓN</h3>
            <p>
              Orientar el trabajo y el esfuerzo hacia la mejora continua, la
              búsqueda permanente de la excelencia en el servicio y la obtención
              de los máximos niveles de satisfacción de nuestros clientes.
            </p>
          </div>
          <div className="card">
            <div className="icon">
              <VisionIcon className="icon" />
            </div>
            <h3>VISIÓN</h3>
            <p>
              Mantenernos fieles a nuestros valores como compañía. Continuar
              enriqueciéndonos de nuevas relaciones empresariales.
            </p>
          </div>
          <div className="card">
            <div className="icon">
              <QualityIcon className="icon" />
            </div>
            <h3>CALIDAD</h3>
            <p>
              Brindar productos y servicios diferenciados a nuestros clientes,
              ofreciendo comodidad y seguridad con el fin de ayudarlos con sus
              necesidades.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Nosotros;
